import { captureException } from './sentryLoader.js';

/**
 * Report a user-facing error to Sentry. Call from every .catch handler that
 * produces visible UI (toast, error state, alert) — this is the contract that
 * makes "if the user saw it, an engineer sees it in Sentry" hold.
 *
 * Skips capture when:
 *   - err.__intentional === true    (designed rejection: auth redirect, payment
 *                                    paywall, client-side input validation)
 *   - err.__sentryReported === true (already captured upstream)
 *
 * The caller still handles the UI side (setError, toast, etc.) — this utility
 * only owns the observability side.
 *
 * @param {Error|null|undefined} err
 * @param {{ context?: string }} [opts] - `context` is a short human-readable
 *   label describing what the user was doing (e.g. "Assignment creation").
 */
export function reportUserFacingError(err, opts = {}) {
  if (!err) return;
  if (err.__intentional) return;
  if (err.__sentryReported) return;

  const { context } = opts;
  captureException(err, { extra: context ? { context } : undefined });
  err.__sentryReported = true;
}
